export default [{
    path: "/order/list",
    component: () => import( /* webpackChunkName: "order" */ '@/page/user/order/list.vue')
}]